"use client";

import { useEffect, type ReactNode } from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import {
  initPostHog,
  isPostHogConfigured,
} from "@/lib/analytics/client";
import type { AnalyticsEnvironment } from "@/lib/analytics/catalog";
import { AnalyticsIdentity } from "@/components/analytics/AnalyticsIdentity";

export function AnalyticsProvider({
  children,
  environment,
}: {
  children: ReactNode;
  environment: AnalyticsEnvironment;
}) {
  const enabled = isPostHogConfigured();

  useEffect(() => {
    if (!enabled) return;
    initPostHog();
  }, [enabled]);

  if (!enabled) return children;

  return (
    <PostHogProvider client={posthog}>
      <AnalyticsIdentity environment={environment} />
      {children}
    </PostHogProvider>
  );
}
